export default '4.24.1';
